import React from "react";
import DicoLeaf from "./Dico";

const GenericLeaf = (props) => {
  // console.log("leaf", props);
  const getSpan = () => {
    return (
      <span
        {...props.attributes}
        style={{
          fontWeight: props.leaf.bold ? "bold" : "normal",
          fontStyle: props.leaf.italic ? "italic" : "normal",
          textDecoration: props.leaf.delete ? "line-through" : "none",
        }}
      >
        {props.children}
      </span>
    );
  };

  if (props.leaf.dico) return <DicoLeaf {...props}>{getSpan()}</DicoLeaf>;
  return getSpan();
};

export default GenericLeaf;
